import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;
export const ProficiencyBox = styled.div`
  max-width: 1128px;
  margin: auto;
  display: flex;
  flex-direction: column;
  @media (max-width: 1100px) {
    margin: 0px 30px;
  }
  @media (max-width: 768px) {
    margin: 10px 10px;
  }
`;

export const ProBar = styled.div`
  border-radius: 50px;
  background-color: var(--hoverback);
  height: 15px;
  position: relative;
  width: 100%;
`;

export const ProText = styled.h2`
  font-size: 16px;
  padding: 0px 0px 15px 0px;
  color: var(--secondary);
`;

export const ProTile = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 0px 15px 0px;
`;
